import React  from 'react';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { IconButton, InputAdornment, OutlinedInput } from "@mui/material"
import { useState } from 'react';
import { useRecoilValue } from 'recoil';
import useSavePatient from 'src/Patient/hooks/useSavePatient';
import { valuesFormRegisterState } from 'src/Patient/state/atoms';
import InputLabelCustom from "src/shared/components/forms/InputLabelCustom"
import usePasswordValidate from '../hooks/usePasswordValidate';

const PasswordField = () => {
    const { uswClave } = useRecoilValue(valuesFormRegisterState);
    const [showPassword, setShowPassword] = useState(false)
    const { handleChange } = useSavePatient();
    const { handleValidatePassword } = usePasswordValidate()
    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    return (
        <>
            <InputLabelCustom htmlFor="input-password" text="Contraseña" />
            <OutlinedInput
                id="input-password"
                size="small"
                //error={errorUswRut && errorUswRut.length > 0 ? true : false}
                //helperText={errorUswRut && errorUswRut.length > 0 ? `${errorUswRut.join("\n")}` : ''}
                style={{ width: '100%' }}
                name="uswClave"
                type={showPassword ? 'text' : 'password'}
                value={uswClave || ""}
                endAdornment={
                    <InputAdornment position="end">
                        <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                        >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                    </InputAdornment>
                }
                onChange={(ev) => {
                    handleChange(ev);
                    handleValidatePassword(ev)
                }}
                autoComplete="off"
            />
        </>
    )
}

export default PasswordField;